/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { SecurityHelper } from 'sarsaparilla';
import { Logo } from 'site-kit';

import styles from './WidgetLogo.module.scss';

interface WidgetLogoProps {
    isCompact?: boolean;
}

export function WidgetLogo({ isCompact = false }: WidgetLogoProps) {
    return (
        <a
            href={SecurityHelper.appendWidgetReferrer('/')}
            target="_blank"
            rel="noreferrer"
            className={cx(styles.widgetLogo, {
                [styles.isCompact]: isCompact,
            })}
        >
            <span className="text-xs color-text-03">Brought to you by</span>
            <Logo />
        </a>
    );
}
